<div class="app-wrapper"
     data-testid="ccm-root">
    <div class="app-scrollable-content">
        <router-outlet></router-outlet>
    </div>
    <app-footer-navigation-bar [menuItems]="tabs"
                               [defaultItem]="selectedTab"
                               (tabChanged)="onTabChanged($event)"
                               data-testid="ccm-footer-nav">
    </app-footer-navigation-bar>
</div>